// `new Date().toISOString().split('T')[0]` reports "today" in UTC, which rolls over to
// tomorrow in the evening for any timezone behind UTC (e.g. America/Edmonton). Build the
// "YYYY-MM-DD" string from local date parts instead so it matches the browser's actual day.
export function todayLocalDateString() {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${now.getFullYear()}-${month}-${day}`;
}
